module.exports = __webpack_public_path__ + "static/media/hands.e336433c.jfif";